import Button from "../../utils/components/Button";
import Input from "../../utils/components/Input";
import Logo from "../../static/crane-login-logo.png";
import "./_register.scss";
const Register = ({ translate }) => {
  return (
    <div className="register container-fluid d-flex flex-column align-items-center justify-content-center px-3">
      <div className="row d-flex align-items-center justify-content-center">
        <div className="col-md-12 col-lg-9 d-flex flex-column align-items-center">
          <img height={200} src={Logo} alt="logo" />
          <p className="text-center my-4 pt-2 fs-5">
            Hoşgeldiniz Sayın Kullanıcı, <br />
            Lütfen aşağıdaki bilgileri doldurarak kaydınızı tamamlayınız.
          </p>
        </div>
        <div className="col-md-12 col-lg-8">
          <form>
            <Input
              type="text"
              name="username"
              className="d-block border-dark p-3"
              placeholder="Kullanıcı Adınızı Giriniz"
              required={true}
            />
            <Input
              type="password"
              name="password"
              className="d-block border-dark p-3"
              placeholder="Parolanızı Giriniz"
              required={true}
            />
            <Input
              type="password"
              name="password"
              className="d-block border-dark p-3"
              placeholder="Parolanızı Tekrar Giriniz"
              required={true}
            />
            <Button type="submit" className="btn-orange w-100 mt-3 p-2">
              Kaydı Tamamla
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Register;
